// extracted by mini-css-extract-plugin
export default {"pdf":"PDFViewerPage_pdf__UDXbX","back":"PDFViewerPage_back__O7Xo6"};